import * as React from "react"

import Container from "../container/container"

const BotanicalVideo = () => {
  return (
    <div style={{ padding: "75px 0" }}>
      <Container>
        <div className={`d-flex align-items-center justify-content-center`}>
          <iframe
            style={{ margin: "0 auto" }}
            width="80%"
            height="500"
            src="https://www.youtube.com/embed/i0JCYn2L4r0"
            title="YouTube video player"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          ></iframe>
        </div>
      </Container>
    </div>
  )
}

export default BotanicalVideo
